import React, { useEffect, useState } from 'react';
import { solicitarRevision } from '../../services/miZonaService';
import { formatearFecha } from './estadosPartido';

export const MAX_TEXTO = 2000;

// Pide al comité que revise un partido (error de puntuaciones, desacuerdo
// sobre un aplazamiento...). El texto llega por correo a fmds.bad@gmail.com.
export default function ModalRevision({ partido, onCerrar }) {
  const [texto, setTexto] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [error, setError] = useState(null);
  const [enviado, setEnviado] = useState(false);

  useEffect(() => {
    const alPulsar = (e) => { if (e.key === 'Escape' && !enviando) onCerrar(); };
    document.addEventListener('keydown', alPulsar);
    return () => document.removeEventListener('keydown', alPulsar);
  }, [enviando, onCerrar]);

  const enviar = async (e) => {
    e.preventDefault();
    setEnviando(true);
    setError(null);
    try {
      await solicitarRevision(partido.id, texto.trim());
      setEnviado(true);
    } catch (err) {
      // El texto se conserva para poder reintentar.
      setError(err.message || 'No se pudo enviar la solicitud.');
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="mz-modal-fondo" onClick={(e) => e.target === e.currentTarget && !enviando && onCerrar()}>
      <div className="mz-modal" role="dialog" aria-modal="true" aria-labelledby="mz-revision-titulo">
        <h3 id="mz-revision-titulo">Solicitar revisión</h3>
        <p className="mz-modal-partido">
          {partido.modalidad} · jornada {partido.jornada} · {partido.local_nombre} vs {partido.visitante_nombre}
          {partido.fecha && <> · {formatearFecha(partido.fecha)}</>}
        </p>

        {enviado ? (
          <>
            <p className="mz-modal-ok" role="status">Solicitud enviada al comité. Te responderán por correo si es necesario.</p>
            <div className="mz-modal-acciones">
              <button type="button" className="btn btn-primary" onClick={onCerrar}>Cerrar</button>
            </div>
          </>
        ) : (
          <form onSubmit={enviar}>
            <label htmlFor="mz-revision-texto">¿Qué quieres comunicar al comité?</label>
            <textarea
              id="mz-revision-texto" rows={6} maxLength={MAX_TEXTO} value={texto} autoFocus
              placeholder="Por ejemplo: error en la puntuación del segundo set, o no estoy de acuerdo con el aplazamiento…"
              onChange={(e) => setTexto(e.target.value)}
            />
            <p className="mz-modal-contador">{texto.length} / {MAX_TEXTO}</p>
            {error && <p className="msg-error" role="alert">{error}</p>}
            <div className="mz-modal-acciones">
              <button type="button" className="btn btn-secondary" disabled={enviando} onClick={onCerrar}>Cancelar</button>
              <button type="submit" className="btn btn-primary" disabled={enviando || texto.trim() === ''}>
                {enviando ? 'Enviando…' : 'Enviar solicitud'}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
